function interpolate(template, values) {
  return String(template || '').replace(/\{([A-Za-z0-9_]+)\}/g, (match, key) => {
    return values && values[key] !== undefined ? String(values[key]) : match;
  });
}

export function readI18n() {
  const fallback = { language: 'ja', messages: {} };
  const el = document.getElementById('app-i18n');
  if (!el) {
    return fallback;
  }

  try {
    const parsed = JSON.parse(el.textContent || '{}');
    return {
      language: parsed.language === 'en' ? 'en' : 'ja',
      messages: parsed.messages && typeof parsed.messages === 'object' ? parsed.messages : {},
    };
  } catch (error) {
    console.warn('Cannot read localization data.', error);
    return fallback;
  }
}

export function createTranslator(i18n) {
  const messages = i18n?.messages || {};
  return (key, values = {}) => interpolate(messages[key] || key, values);
}
